export enum CourseType {
    chemistry = 'chemistry',
    physics = 'physics'
}

export enum URI {
    base = '/',
    register = '/register',
    clinicalCase = '/clinical-case',
    dashboard = '/dashboard',
    monitoria = '/monitoria',
    exams = '/exams',
    examAnswer = '/exams/answers',
    examResults = '/exams/results',
    lessons = '/lessons/:id?',
    digitalMaterial = '/digital',
    handout = '/digital/handout',
    examResolution = '/digital/exam-resolution',
    examResolutionParams = '/digital/exam-resolution/:examId/:questionIndex',
    longExamResolution = '/digital/long-exam-resolution',
    longExamResolutionParams = '/digital/long-exam-resolution/:examId/:questionIndex',
    handoutResolution = '/digital/handout-resolution',
    handoutResolutionParams = '/digital/handout-resolution/:id',
    statistics = '/statistics',
    chapter = '/chapter/:id',
    longExam = '/digital/long-exams',
    longExamAnswers = '/digital/long-exams/answers',
    longExamResults = '/digital/long-exams/results',
    extraLessons = '/digital/extra-lessons',
    extraContent = '/digital/extra-content',
}

export enum TutoringType {
    monitoring = 'monitoria',
    tutoring = 'tutoria'
}